import type { Run } from '@/types/monitoring';
import type { WorkflowDefinition } from '@/types/workflowDefinition';

export type TriggerDetailsMode = 'request' | 'default' | 'unsupported';

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

/** Historical capabilities belong to the run, not the current editor mode. */
export function getTriggerDetailsMode(
  run: Run | undefined,
  nodeId: string | null,
  workflow: WorkflowDefinition | null,
  isAgenticWorkflow: boolean,
): TriggerDetailsMode {
  if (!nodeId?.startsWith('trigger-')) return 'default';
  if (!run) return 'unsupported';
  const snapshot = run.workflowSnapshot ?? workflow;
  if (snapshot?.kind?.toLowerCase() === 'agent') return 'unsupported';
  const triggers: unknown = snapshot?.definition.triggers;
  const trigger = isRecord(triggers) ? triggers[nodeId.slice('trigger-'.length)] : undefined;
  if (isRecord(trigger) && typeof trigger.type === 'string' && trigger.type.toLowerCase() === 'request') {
    const kind = trigger.kind;
    if (kind === undefined || (typeof kind === 'string' && kind.toLowerCase() === 'http')) return 'request';
  }
  return isAgenticWorkflow ? 'unsupported' : 'default';
}
